/**
 * Show an info banner prompting the user to accept the new Terms of Service.
 * When the user is part of a single seat account, or is the admin of a multi-seat account,
 * check if they've accepted the ToS already; if they haven't accepted, show the banner.
 */
define('banner/custom-banners/terms-of-service',['require','jquery','durandal/app','lodash','api-access','api-access','api-access','i18next'],function (require) {
    var $ = require('jquery');
    var app = require('durandal/app');
    var _ = require('lodash');
    var userApi = require('api-access').user;
    var commerceApi = require('api-access').commerce;
    var meetingsApi = require('api-access').meetings;
    var i18n = require('i18next');

    return {
        initialize: function () {
            userApi.me().then(function (userMe) {
                if (userMe.grantedAuthorities.indexOf('ROLE_EXT_ADMIN') > -1) {
                    return meetingsApi.account();
                }

                return commerceApi.getProducts().then(function (products) {
                    if (_.find(products, {product: 'GoToMeeting', active: true, seats: 1})) {
                        return meetingsApi.account();
                    }

                    return $.Deferred().reject();
                });
            })
                .then(function (account) {
                    if (!account.termsofserviceaccepteduseremail) {
                        var faqUrl = 'https://secure.logmein.com/home/en/policies/terms-and-conditions';
                        var tosUrl = i18n.t('web-urls.urls.termsofservice');

                        var messageText;
                        var messageButton;
                        var termsOfServiceBanner;
                        var acceptHandler;

                        messageText = i18n.t('termsofservice.changed',
                            '<a target="_blank" href="' + tosUrl + '">', '</a>',
                            '<a target="_blank" href="' + faqUrl + '">', '</a>');

                        messageButton = '<div><button class="btn btn-info tos-accept">' +
                                i18n.t('termsofservice.accept') +
                            '</button></div>';

                        // Click handler for the accept button.
                        // Includes API call to mark the ToS as read.
                        acceptHandler = function (bannerData) {
                            var element = $(bannerData.element);
                            $(element.find('.tos-accept')).click(function (event) {
                                event.preventDefault();
                                app.trigger('banner:remove', termsOfServiceBanner);
                                meetingsApi.acceptTos();
                            });
                        };

                        termsOfServiceBanner = {
                            id: 'terms-of-service',
                            classes: 'alert-info',
                            iconClasses: 'togo-icon togo-icon-info',
                            title: i18n.t('termsofservice.termsofservice'),
                            message: messageText + messageButton,
                            onAddSuccess: acceptHandler,
                            disableTime: 3600000 // 1 hour
                        };

                        app.trigger('banner:addOne', termsOfServiceBanner);
                    }
                });
        }
    };
});

